// @flow weak
import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { Provider } from "react-redux";
import configureStore from "./redux/store/configureStore";
import { history } from "./redux/store/configureStore";
// import App from "./containers/app";
// import MainRoutes             from './routes/MainRoutes';
import DashboardConnected from "./views/admin/home";
import MerchantList from "./views/admin/merchant/MerchantList";
import Authorization from "./routes/Authorization";
import InitialSetup from "./InitialSetup.js";

import _ from "lodash";

import CacheBuster from "react-cache-buster";
import { version } from "./package.json";

// #region flow types
type Props = any;
type State = any;

// #endregion

const store = configureStore();
const Admin = Authorization(["admin"]);
const forgotUsers = Authorization(["admin", "merchant"]);
const SuperAdmin = Authorization(["superadmin", "admin"]);
const isProduction = process.env.NODE_ENV === "production";

class Root extends Component {
  renderInitialView() {
    return <InitialSetup />;
  }

  render() {
    const user = {};

    return (
      <CacheBuster
        currentVersion={version}
        isEnabled={isProduction} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
      >
        <Provider store={store}>{this.renderInitialView()}</Provider>
      </CacheBuster>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/app/Root.js